import { useQuery } from '@tanstack/react-query'
import api from '@/admin/lib/api'
import { useOrg } from '@/admin/hooks/use-org'
import { useSession } from '@/admin/hooks/use-session'

export function usePermissions() {
  const { data: orgContext, isLoading: orgLoading } = useOrg()
  const { data: session, isLoading: sessionLoading } = useSession()
  const { data, isLoading } = useQuery<{ permissions: string[]; is_admin?: boolean }>({
    queryKey: ['permissions'],
    queryFn: () => api.get('/auth/rbac/my-permissions/').then((r) => r.data),
    staleTime: 60_000,
  })

  const permissions = new Set([
    ...(orgContext?.permissions ?? []),
    ...(data?.permissions ?? []),
  ])
  const isAdmin =
    Boolean(data?.is_admin) ||
    Boolean(session?.user?.is_staff) ||
    Boolean(session?.user?.is_superuser)

  return {
    permissions,
    isAdmin,
    can: (codename: string) => isAdmin || permissions.has(codename),
    isLoading: isLoading || orgLoading || sessionLoading,
  }
}
